import React, {useContext} from "react";
import { GERMAN } from "../actions/language";
import {LanguageContext} from "../context/LanguageContext";
import {PlatformContext} from "../context/PlatformContext";
import {DESKTOP} from "../actions/mobile";
import {OFFICE_CONTACT_EMAIL, OFFICE_CONTACT_OFFICE_PHONE_NUMBER} from "../env";

const Agb = () => {
    const { language } = useContext(LanguageContext);
    const { platform } = useContext(PlatformContext);

    return (
        <div className="container fancy-paragraph" style={{marginBottom: "80px"}}>
            <h1 className="text-center p-standard-top fancy-title"
                style={platform === DESKTOP
                    ? {fontSize: "40px", marginTop: "100px", marginBottom: "40px"}
                    : {fontSize: "20px", marginTop: "100px", marginBottom: "40px"}}
            >
                <b>
                    {
                        language === GERMAN ?
                            'Allgemeine Geschäftsbedingungen (AGB) und Kundeninformationen' : 'Termos e condições gerais (TCG) e informações para clientes'
                    }
                </b>
            </h1>
            <div className={platform === DESKTOP ? "fancy-paragraph justify" : "fancy-paragraph"}>
                <p>
                    <b>
                        {
                            language === GERMAN ?
                                '1. Geltungsbereich' : '1. Âmbito de aplicação'
                        }
                    </b>
                </p>
                <p>
                    {
                        language === GERMAN ?
                            'Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Dienstleistungen, die von Tome & Martins Dienstleistungen angeboten werden. Sie regeln die Rechte und Pflichten zwischen uns und unseren Kunden.' : 'Os presentes Termos e Condições Gerais (TCG) aplicam-se a todos os serviços oferecidos pela Tome & Martins Dienstleistungen. Elas regem os direitos e obrigações entre nós e os nossos clientes.'
                    }
                </p>
                <p>
                    <b>
                        {
                            language === GERMAN ?
                                '2. Vertragsschluss' : '2. Celebração do contrato'
                        }
                    </b>
                </p>
                <p>
                    {
                        language === GERMAN ?
                            'Ein Vertrag kommt zustande, wenn der Kunde unser Angebot annimmt oder wir einen erteilten Auftrag bestätigen. Dies kann schriftlich oder durch die Erbringung der Dienstleistung erfolgen.' : 'Um contrato é celebrado quando o cliente aceita a nossa oferta ou quando confirmamos uma encomenda. Isto pode ocorrer por escrito ou através da prestação do serviço.'
                    }
                </p>
                <p>
                    <b>
                        {
                            language === GERMAN ?
                                '3. Leistungsumfang' : '3. Âmbito dos serviços'
                        }
                    </b>
                </p>
                <p>
                    {
                        language === GERMAN ?
                            'Wir bieten Dienstleistungen in den Bereichen Büroservice, organisatorische Hilfestellungen und allgemeine Verwaltungsaufgaben an. Die genauen Leistungen werden individuell vereinbart.' : 'Oferecemos serviços nas áreas de suporte administrativo, assistência organizacional e tarefas gerais de gestão. Os serviços específicos são acordados individualmente.'
                    }
                </p>
                <p>
                    <b>
                        {
                            language === GERMAN ?
                                '4. Pflichten des Kunden' : '4. Obrigações do cliente'
                        }
                    </b>
                </p>
                <p>
                    {
                        language === GERMAN ?
                            'Der Kunde stellt sicher, dass alle für die Leistungserbringung notwendigen Informationen und Unterlagen vollständig und rechtzeitig bereitgestellt werden.' : 'O cliente garante que todas as informações e documentos necessários para a prestação do serviço sejam fornecidos de forma completa e atempada.'
                    }
                </p>
                <p>
                    <b>
                        {
                            language === GERMAN ?
                                '5. Preise und Zahlungsbedingungen' : '5. Preços e condições de pagamento'
                        }
                    </b>
                </p>
                <p>
                    {
                        language === GERMAN ?
                            'Die Preise richten sich nach den individuell vereinbarten Konditionen. Zahlungen sind nach Rechnungsstellung innerhalb der angegebenen Frist zu leisten.' : 'Os preços são baseados nas condições acordadas individualmente. Os pagamentos devem ser efetuados após a emissão da fatura dentro do prazo especificado.'
                    }
                </p>
                <p>
                    <b>
                        {
                            language === GERMAN ?
                                '6. Haftung' : '6. Responsabilidade'
                        }
                    </b>
                </p>
                <p>
                    {
                        language === GERMAN ?
                            'Unsere Haftung beschränkt sich auf Vorsatz und grobe Fahrlässigkeit. Eine weitergehende Haftung ist ausgeschlossen, soweit gesetzlich zulässig.' : 'A nossa responsabilidade limita-se a dolo e negligência grave. Qualquer responsabilidade adicional está excluída, na medida permitida por lei.'
                    }
                </p>
                <p>
                    <b>
                        {
                            language === GERMAN ?
                                '7. Datenschutz' : '7. Proteção de dados'
                        }
                    </b>
                </p>
                <p>
                    {
                        language === GERMAN ?
                            'Wir verarbeiten personenbezogene Daten ausschließlich im Rahmen der gesetzlichen Vorschriften. Weitere Informationen finden Sie in unserer Datenschutzerklärung.' : 'Tratamos os dados pessoais exclusivamente de acordo com os regulamentos legais. Para mais informações, consulte a nossa política de privacidade.'
                    }
                </p>
                <h1 className="text-center fancy-title" style={{marginTop: "100px", marginBottom: "40px"}}>
                    <b>
                        {
                            language === GERMAN ?
                                'Kundeninformationen' : 'Informações para clientes'
                        }
                    </b>
                </h1>
                <p>
                    <b>
                        {
                            language === GERMAN ?
                                '1. Identität des Dienstleisters' : '1. Identidade do prestador de serviços'
                        }
                    </b>
                </p>
                <p>
                    {
                        language === GERMAN ?
                            'Tome & Martins Dienstleistungen, spezialisiert auf Büroservice und Verwaltungsdienstleistungen. Weitere Informationen finden Sie auf unserer Website.' : 'Tome & Martins Services, especializada em serviços de escritório e administrativos. Para mais informações, consulte o nosso sítio Web.'
                    }
                </p>
                <p>
                    <b>
                        {
                            language === GERMAN ?
                                '2. Kontaktmöglichkeiten' : '2. Meios de contato'
                        }
                    </b>
                </p>
                <p className="p-standard-bottom">
                    {
                        language === GERMAN ?
                            'Sie erreichen uns per E-Mail unter ' + OFFICE_CONTACT_EMAIL + ' oder telefonisch unter ' + OFFICE_CONTACT_OFFICE_PHONE_NUMBER + '.' : 'Pode contactar-nos por e-mail em ' + OFFICE_CONTACT_EMAIL + ' ou por telefone no ' + OFFICE_CONTACT_OFFICE_PHONE_NUMBER + '.'
                    }
                </p>
            </div>
        </div>
    );
}

export default Agb


// WEBPACK FOOTER //
// ./src/components/Agb.js